<div class="dialog-setup">
  <button class="close" mat-button (click)="onNoClick()">X</button>

  <div class="profile-title">
    <h2 class="profile-head">Account Details</h2>
  </div>
  <div class="profile-body">
    <!-- Edit Button  -->
    <!-- Username, Name, Surname, Email, Phone Number -->

    <fieldset [disabled]="!editEnabled">
      <mat-form-field appearance="standard" color="accent">
        <mat-label>Username</mat-label>
        <input type="email" matInput [formControl]="emailFormControl">
      </mat-form-field>
    </fieldset>

    <fieldset [disabled]="!editEnabled">
      <mat-form-field appearance="standard" color="accent">
        <mat-label>First name</mat-label>
        <input type="text" matInput [formControl]="nameFormControl">
      </mat-form-field>
    </fieldset>

    <fieldset [disabled]="!editEnabled">
      <mat-form-field appearance="standard" color="accent">
        <mat-label>Last name (optional)</mat-label>
        <input type="text" matInput [formControl]="surnameFormControl">
      </mat-form-field>
    </fieldset>

    <fieldset [disabled]="!editEnabled">
      <mat-form-field appearance="standard" color="accent">
        <mat-label>Phone Number (optional)</mat-label>
        <input type="tel" matInput [formControl]="phoneFormControl" placeholder="060 779 2177">
      </mat-form-field>
    </fieldset>

  </div>
  <div class="profile-footer">
    <!-- <button mat-raised-button class="btn-block change-pw-button"
      (click)="toggleEdit()">{{editEnabled?"Submit":"Edit User Details"}}</button> -->

    <button mat-raised-button class="btn-block change-pw-button" (click)="changePassword()">Change Password</button>
  </div>
</div>
